import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Calculator, FileText } from 'lucide-react';
import { fmtEur } from '../lib/taxHelpers';

export const TaxResultCard = (props) => {
  const idx = props.idx;
  const title = props.title;
  const tone = props.tone;
  const total = props.total;
  const lines = props.lines || [];

  const isAmber = tone === 'amber';
  const headClass = isAmber
    ? 'bg-amber-50 border-b border-amber-200 text-amber-900'
    : 'bg-emerald-50 border-b border-emerald-200 text-emerald-900';
  const boxClass = isAmber ? 'border-amber-300 bg-amber-50/40' : 'border-emerald-300 bg-emerald-50/40';
  const labelClass = isAmber ? 'text-amber-700' : 'text-emerald-700';
  const valueClass = isAmber ? 'text-amber-900' : 'text-emerald-900';

  const lineItems = [];
  for (let i = 0; i < lines.length; i += 1) {
    lineItems.push(
      <li key={i} className="flex gap-2" data-testid={`tax-result-step-${idx}-${i}`}>
        <span className="text-slate-400 font-mono shrink-0">{i + 1}.</span>
        <span>{lines[i]}</span>
      </li>,
    );
  }

  return (
    <Card className="border border-slate-200" data-testid={`tax-result-card-${idx}`}>
      <CardHeader className={headClass}>
        <CardTitle className="font-outfit text-base flex items-center gap-2">
          <FileText className="w-4 h-4" /> {title}
        </CardTitle>
      </CardHeader>
      <CardContent className="p-4 space-y-3">
        <div className={`rounded-md border-2 ${boxClass} p-4`}>
          <p className={`text-xs uppercase tracking-wide font-medium ${labelClass}`}>Impôt total à payer</p>
          <p
            className={`font-outfit text-3xl font-bold ${valueClass} mt-1 font-mono`}
            data-testid={`tax-result-total-${idx}`}
          >
            {fmtEur(total)}
          </p>
        </div>
        <div className="rounded-md border border-slate-200 bg-slate-50 p-3">
          <p className="text-xs uppercase tracking-wide font-medium text-slate-500 mb-2 flex items-center gap-2">
            <Calculator className="w-3.5 h-3.5" /> Détail du calcul
          </p>
          <ol className="space-y-1 text-xs text-slate-700">{lineItems}</ol>
        </div>
      </CardContent>
    </Card>
  );
};

export default TaxResultCard;
